import {connect} from 'react-redux';
import BalanceDetail from './BalanceDetail.jsx';
import {
  handlePaymentLogClick,
  handleEntryDetailPaymentClick,
  handleEntryDetailCreditCardPaymentClick,
  handleEntryDetailRefundClick
} from './actions';
import {handleWebHooksClick} from 'shared/webHooks/actions';
import {ENVIRONMENT} from 'shared/variables';

const mapStateToProps = state => ({
  balance: state.admin.entryDetail.balance,
  showPaymentLog: state.admin.entryDetail.showPaymentLog,
  isCancelled: state.admin.entryDetail.isCancelled,
  selectedEntriesWithoutBalance: state.admin.captainDetail.selectedEntriesWithoutBalance,
  environment: ENVIRONMENT
});

const mapDispatchToProps = dispatch => ({
  onPaymentLogClick: () => dispatch(handlePaymentLogClick()),
  onEntryDetailPaymentClick: () => dispatch(handleEntryDetailPaymentClick()),
  onEntryDetailCreditCardPaymentClick: () => dispatch(handleEntryDetailCreditCardPaymentClick()),
  onRefundClick: () => dispatch(handleEntryDetailRefundClick()),
  onWebHooksClick: (checked) => dispatch(handleWebHooksClick(checked))
});

export default connect(mapStateToProps, mapDispatchToProps)(BalanceDetail);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/BalanceDetailContainer.jsx